var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.8859 140.497C115.429 140.497 141.01 115.109 141.01 83.758C141.01 52.407 115.429 27.0186 83.8859 27.0186C52.3426 27.0186 26.7617 52.407 26.7617 83.758C26.7617 115.109 52.3426 140.497 83.8859 140.497Z",
    fill: "#202531"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.643 76.3526V111.069C127.643 118.282 121.776 124.148 114.468 124.148H53.4967C46.284 124.148 40.4177 118.378 40.3215 111.166C40.3215 111.069 40.3215 111.069 40.3215 110.973V76.3526C40.3215 76.2564 40.3215 76.2564 40.3215 76.1602C40.3215 75.9679 40.3215 75.7756 40.4177 75.5832C40.5139 75.2947 40.61 75.1024 40.7062 74.8139L57.0549 43.5591C57.6319 42.3089 58.8821 41.6357 60.2285 41.6357H107.64C108.986 41.6357 110.14 42.3089 110.813 43.5591L127.162 74.8139C127.258 75.0062 127.354 75.2947 127.45 75.5832C127.643 75.7756 127.643 76.0641 127.643 76.3526Z",
    fill: "url(#paint0_linear_154_719)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_154_719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.643 76.3526V114.628C127.643 119.917 123.412 124.148 118.026 124.148H49.9387C44.6494 124.148 40.3218 119.917 40.3218 114.628V76.1603C40.3218 75.9679 40.3218 75.7756 40.4179 75.5833H62.3444C65.6142 75.5833 68.3069 78.1798 68.3069 81.5457C68.3069 83.1806 68.9801 84.7193 70.0379 85.7771C71.1919 86.9311 72.5383 87.5081 74.2693 87.5081H93.7916C97.0613 87.5081 99.7541 84.9116 99.7541 81.5457C99.7541 79.9108 100.427 78.3721 101.485 77.3143C102.639 76.1603 103.985 75.5833 105.62 75.5833H127.451C127.643 75.7756 127.643 76.0641 127.643 76.3526Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.643 76.3526V114.628C127.643 119.917 123.412 124.148 118.026 124.148H49.9387C44.6494 124.148 40.3218 119.917 40.3218 114.628V76.1603C40.3218 75.9679 40.3218 75.7756 40.4179 75.5833H62.3444C65.6142 75.5833 68.3069 78.1798 68.3069 81.5457C68.3069 83.1806 68.9801 84.7193 70.0379 85.7771C71.1919 86.9311 72.5383 87.5081 74.2693 87.5081H93.7916C97.0613 87.5081 99.7541 84.9116 99.7541 81.5457C99.7541 79.9108 100.427 78.3721 101.485 77.3143C102.639 76.1603 103.985 75.5833 105.62 75.5833H127.451C127.643 75.7756 127.643 76.0641 127.643 76.3526Z",
    fill: "url(#paint1_linear_154_719)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.55 56.6378C141.728 56.6378 143.493 54.8683 143.493 52.6949C143.493 50.5215 141.728 48.752 139.55 48.752C137.372 48.752 135.607 50.5215 135.607 52.6949C135.607 54.8683 137.372 56.6378 139.55 56.6378Z",
    fill: "#404756"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.608 43.8474C137.095 43.8474 138.3 42.6452 138.3 41.1546C138.3 39.664 137.095 38.4619 135.608 38.4619C134.12 38.4619 132.915 39.664 132.915 41.1546C132.915 42.6452 134.12 43.8474 135.608 43.8474Z",
    fill: "#404756"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5521 52.695C28.0389 52.695 29.2448 51.4929 29.2448 50.0023C29.2448 48.5117 28.0389 47.3096 26.5521 47.3096C25.0644 47.3096 23.8594 48.5117 23.8594 50.0023C23.8594 51.4929 25.0644 52.695 26.5521 52.695Z",
    fill: "#404756"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4939 111.935C23.2559 111.935 25.4947 109.694 25.4947 106.934C25.4947 104.174 23.2559 101.934 20.4939 101.934C17.732 101.934 15.4932 104.174 15.4932 106.934C15.4932 109.694 17.732 111.935 20.4939 111.935Z",
    fill: "#404756"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.044 30.0667C109.299 43.7707 109.926 46.9058 107.084 59.3115C106.16 62.0715 105.236 65.0912 103.255 67.1973C100.484 70.4767 95.4667 71.9192 91.3747 70.871C87.15 69.8227 83.7177 66.1395 82.9253 61.6772C82.2656 58.9172 83.1898 55.6379 85.5661 53.9261C88.0742 52.3489 91.6382 52.7432 93.751 54.7146C96.1274 56.6861 97.0515 59.7058 96.9188 62.6005C96.7871 65.4855 95.7311 68.3802 94.279 70.871C90.9958 77.0065 89.6446 76.9873 82.9253 87.0657",
    stroke: "#ABB5CC",
    strokeWidth: 1.92337,
    strokeDasharray: "3.85 3.85"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.404 24.9599C114.902 26.7967 112.895 27.4603 110.888 26.2966C108.714 25.2965 107.209 24.4598 107.542 22.7961C108.044 21.1324 110.051 20.9689 112.393 20.8054C115.237 20.4688 115.739 23.1327 115.404 24.9599Z",
    fill: "#DAE2EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1787 26.6232C100.015 28.1235 102.357 29.1236 104.029 27.6234C105.869 25.9597 107.374 24.796 106.538 23.1323C105.702 21.6321 104.364 22.1322 101.52 22.4688C99.1787 22.9688 98.1747 24.9595 99.1787 26.6232Z",
    fill: "#DAE2EB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.538 20.4691C107.709 20.3056 108.88 20.9691 109.215 21.9693C109.382 22.2963 109.549 22.7963 109.549 23.1329C109.883 25.4602 109.047 27.4605 107.709 27.624C106.204 27.9606 104.699 26.2969 104.531 24.1331C104.531 23.4599 104.531 23.1329 104.531 22.6329C104.699 21.4692 105.367 20.6326 106.538 20.4691Z",
    fill: "#657289"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0098 101.317C74.2283 101.317 75.2159 100.327 75.2159 99.1056C75.2159 97.8938 74.2283 96.9033 73.0098 96.9033C71.7914 96.9033 70.8037 97.8938 70.8037 99.1056C70.8037 100.327 71.7914 101.317 73.0098 101.317Z",
    fill: "#D5DDEA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9542 101.317C96.1726 101.317 97.1603 100.327 97.1603 99.1056C97.1603 97.8938 96.1726 96.9033 94.9542 96.9033C93.7357 96.9033 92.748 97.8938 92.748 99.1056C92.748 100.327 93.7357 101.317 94.9542 101.317Z",
    fill: "#D5DDEA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5598 115.81H80.6424C79.5692 115.81 78.6748 114.916 78.6748 113.839C78.6748 112.762 79.5692 111.867 80.6424 111.867H87.5002C88.5735 111.867 89.4678 112.762 89.4678 113.839C89.5274 114.916 88.6331 115.81 87.5598 115.81Z",
    fill: "#D5DDEA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_154_719",
    x: 19.1647,
    y: 65.0047,
    width: 129.635,
    height: 90.8793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.5785
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5785
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_154_719"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_154_719",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_719",
    x1: 83.9821,
    y1: 41.6357,
    x2: 83.9821,
    y2: 124.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_154_719",
    x1: 83.9824,
    y1: 75.5833,
    x2: 83.9824,
    y2: 124.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65748E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F5C72"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.4a661eefe02d893ed7c5d8942fe94504.svg";
export { ForwardRef as ReactComponent };